import { PhotoGsd } from "./Network";
import { AbandonedVehicleReviewStatus } from "./Network";
import { AbandonedVehicleStatus } from "./Network";
import { PasswordResetType } from "./Network";
import { VehicleSituation } from "./Network";
export function showPhotoGsd( value: PhotoGsd ): string {
    switch( value ) {
        case PhotoGsd.R7p5CM: return "R7p5CM";
        case PhotoGsd.R15CM: return "R15CM";
        case PhotoGsd.R30CM: return "R30CM";
        default: return "Err!";
    }
}

export function readPhotoGsd( displayText: string ): PhotoGsd | undefined {
    switch( displayText ) {
        case "R7p5CM": return PhotoGsd.R7p5CM;
        case "R15CM": return PhotoGsd.R15CM;
        case "R30CM": return PhotoGsd.R30CM;
        default: return undefined;
    }
}

export function showAbandonedVehicleReviewStatus( value: AbandonedVehicleReviewStatus ): string {
    switch( value ) {
        case AbandonedVehicleReviewStatus.New: return "New";
        case AbandonedVehicleReviewStatus.NotActionable: return "Allow";
        case AbandonedVehicleReviewStatus.Actionable: return "Enforce";
        default: return "Err!";
    }
}

export function readAbandonedVehicleReviewStatus( displayText: string ): AbandonedVehicleReviewStatus | undefined {
    switch( displayText ) {
        case "New": return AbandonedVehicleReviewStatus.New;
        case "Allow": return AbandonedVehicleReviewStatus.NotActionable;
        case "Enforce": return AbandonedVehicleReviewStatus.Actionable;
        default: return undefined;
    }
}

export function showAbandonedVehicleStatus( value: AbandonedVehicleStatus ): string {
    switch( value ) {
        case AbandonedVehicleStatus.Candidate: return "Detected";
        case AbandonedVehicleStatus.ReviewedUnsure: return "Unsure";
        case AbandonedVehicleStatus.ReviewedVerified: return "Verified";
        case AbandonedVehicleStatus.ReviewedRejected: return "Rejected";
        case AbandonedVehicleStatus.ReviewedRejectedIdentity: return "Different Vehicle";
        case AbandonedVehicleStatus.ReviewedRejectedMoved: return "Vehicle Moved";
        case AbandonedVehicleStatus.ReviewedRejectedDeparted: return "Vehicle Departed";
        case AbandonedVehicleStatus.ReviewedRejectedArrived: return "Vehicle Arrived";
        case AbandonedVehicleStatus.ReviewedRejectedNotAVehicle: return "Not a Vehicle";
        case AbandonedVehicleStatus.InPersonUnsure: return "In-Person Unsure";
        case AbandonedVehicleStatus.InPersonVerified: return "In-Person Verified";
        case AbandonedVehicleStatus.InPersonRejected: return "In-Person Rejected";
        case AbandonedVehicleStatus.Impounded: return "Impounded";
        case AbandonedVehicleStatus.Released: return "Released";
        case AbandonedVehicleStatus.Scrapped: return "Scrapped";
        default: return "Err!";
    }
}

export function readAbandonedVehicleStatus( displayText: string ): AbandonedVehicleStatus | undefined {
    switch( displayText ) {
        case "Detected": return AbandonedVehicleStatus.Candidate;
        case "Unsure": return AbandonedVehicleStatus.ReviewedUnsure;
        case "Verified": return AbandonedVehicleStatus.ReviewedVerified;
        case "Rejected": return AbandonedVehicleStatus.ReviewedRejected;
        case "Different Vehicle": return AbandonedVehicleStatus.ReviewedRejectedIdentity;
        case "Vehicle Moved": return AbandonedVehicleStatus.ReviewedRejectedMoved;
        case "Vehicle Departed": return AbandonedVehicleStatus.ReviewedRejectedDeparted;
        case "Vehicle Arrived": return AbandonedVehicleStatus.ReviewedRejectedArrived;
        case "Not a Vehicle": return AbandonedVehicleStatus.ReviewedRejectedNotAVehicle;
        case "In-Person Unsure": return AbandonedVehicleStatus.InPersonUnsure;
        case "In-Person Verified": return AbandonedVehicleStatus.InPersonVerified;
        case "In-Person Rejected": return AbandonedVehicleStatus.InPersonRejected;
        case "Impounded": return AbandonedVehicleStatus.Impounded;
        case "Released": return AbandonedVehicleStatus.Released;
        case "Scrapped": return AbandonedVehicleStatus.Scrapped;
        default: return undefined;
    }
}

export function showPasswordResetType( value: PasswordResetType ): string {
    switch( value ) {
        case PasswordResetType.Initial: return "Initial";
        case PasswordResetType.Forgot: return "Forgot";
        default: return "Err!";
    }
}

export function readPasswordResetType( displayText: string ): PasswordResetType | undefined {
    switch( displayText ) {
        case "Initial": return PasswordResetType.Initial;
        case "Forgot": return PasswordResetType.Forgot;
        default: return undefined;
    }
}

export function showVehicleSituation( value: VehicleSituation ): string {
    switch( value ) {
        case VehicleSituation.Street: return "Street";
        case VehicleSituation.Shoulder: return "Shoulder";
        case VehicleSituation.Sidewalk: return "Sidewalk";
        case VehicleSituation.Field: return "Field";
        case VehicleSituation.Alleyway: return "Alleyway";
        case VehicleSituation.Driveway: return "Driveway";
        case VehicleSituation.ParkingLot: return "ParkingLot";
        case VehicleSituation.Junkyard: return "Junkyard";
        case VehicleSituation.Worksite: return "Worksite";
        case VehicleSituation.Industrial: return "Industrial";
        default: return "Err!";
    }
}

export function readVehicleSituation( displayText: string ): VehicleSituation | undefined {
    switch( displayText ) {
        case "Street": return VehicleSituation.Street;
        case "Shoulder": return VehicleSituation.Shoulder;
        case "Sidewalk": return VehicleSituation.Sidewalk;
        case "Field": return VehicleSituation.Field;
        case "Alleyway": return VehicleSituation.Alleyway;
        case "Driveway": return VehicleSituation.Driveway;
        case "ParkingLot": return VehicleSituation.ParkingLot;
        case "Junkyard": return VehicleSituation.Junkyard;
        case "Worksite": return VehicleSituation.Worksite;
        case "Industrial": return VehicleSituation.Industrial;
        default: return undefined;
    }
}

